import React from "react";
import PropTypes from "prop-types";
import { Result, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

export default function ValueErrorPlaceholder({ title = "Error Loading Data", description, onRetry }) {
  return (
    <div className="h-full flex flex-col rounded-md">
      <div className="flex-grow flex items-center justify-center bg-red-50">
        <div className="text-center p-8 max-w-md w-full">
          <Result
            status="error"
            icon={<FontAwesomeIcon icon={faTriangleExclamation} style={{ color: "#cf1322", fontSize: 48 }} />}
            title={title}
            subTitle={description}
            extra={
              onRetry
                ? [
                    <Button key="retry" type="primary" danger onClick={onRetry}>
                      Retry
                    </Button>,
                  ]
                : null
            }
          />
        </div>
      </div>
    </div>
  );
}

ValueErrorPlaceholder.propTypes = {
  title: PropTypes.string,
  description: PropTypes.node,
  onRetry: PropTypes.func,
};